import { render, staticRenderFns } from "./base-debugger.vue?vue&type=template&id=557efde1&"
import script from "./base-debugger.vue?vue&type=script&lang=js&"
export * from "./base-debugger.vue?vue&type=script&lang=js&"
import style0 from "./base-debugger.vue?vue&type=style&index=0&id=557efde1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports